


































import { Component, Vue, Prop } from 'vue-property-decorator';
import { GET_CAR } from './getCar';

@Component
export default class CarShow extends Vue {
  public GET_CAR = GET_CAR;
  @Prop(String) public id!: string;
}
